import React, { useState, useEffect } from 'react';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import { FieldOptions } from './FieldOptions';
import { FormFieldChecklist } from './FormFieldChecklist';
import { FormFieldSelectionList } from './FormFieldSelectionList';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(1),
      padding: theme.spacing(1),

      // width: theme.spacing(16),
      // height: theme.spacing(16),
    },
  },
  paper: {
    margin: theme.spacing(1),
    padding: theme.spacing(1),
  },
}));

export const FormField = ({ field, formId }) => {
  const classes = useStyles();
  const [fieldEntries, setFieldEntries] = useState([]);

  useEffect(() => {
    let fieldsEntries = Object.entries(field).map(([key, value]) => {
      if (field.type === 'CheckBox' && key === 'checklistItems') {
        return <FormFieldChecklist key={key} value={value} />;
      } else if (field.type === 'Seleção de Lista' && key === 'selectItems') {
        return <FormFieldSelectionList value={value} />;
      } else if (typeof value === 'boolean') {
        return (
          <div>
            {key} : {value} {value === true && <CheckBoxIcon />}
            {value === false && <CheckBoxOutlineBlankIcon />}
          </div>
        );
      } else {
        return (
          <div>
            {key} : {value}
          </div>
        );
      }
    });

    setFieldEntries(fieldsEntries);
  }, [field]);

  return (
    <div className={classes.root}>
      <Paper elevation={3} className={classes.paper}>
        <div>
          <strong>{field.name}</strong>
        </div>
        Field Info:
        {fieldEntries.map((entry, index) => (
          <div key={index}>{entry}</div>
        ))}
        <FieldOptions field={field} formId={formId} />
      </Paper>
    </div>
  );
};
